import React, { useState } from 'react';
import { Row, Col, Table, Button, Container } from 'reactstrap';
import { T } from '../traks';
import I18N from '../I18N';
import ChangeArrow from '../c/ChangeArrow';
import { Apify } from '../Apify';
import { mainGameId } from '../GameConfig';

const PAGE_SIZE = 50;

const PaginatedLeaderboardResource = Apify("/z/paginated_leaderboard", {})
  .with_query_from_props(({ gameId, page }) => ({
    game_id: mainGameId,
    offset: page * PAGE_SIZE,
    limit: PAGE_SIZE,
  }))
  .with_props_from_response(data => ({
    portfolios: data.Portfolios || [],
    game: data,
    totalPlayers: data.PlayerCount || 0,
  }));

function calcDeltaMoney(value, initial) {
  return value - initial;
}
function calcDeltaPct(value, initial) {
  if (!initial) return 0;
  return ((value / initial) - 1) * 100;
}

export default function PublicLeaderboardPaginated({ gameId }) {
  const [page, setPage] = useState(0);

  const LeaderboardBody = PaginatedLeaderboardResource.wrap(
    ({ portfolios, game, totalPlayers, loading, error }) => {
      if (loading) return <div>Loading...</div>;
      if (error) return <div className="text-danger">Error: {error.message || error}</div>;
      if (!game) return null;

      const totalPages = Math.ceil((totalPlayers || 1) / PAGE_SIZE);

      return (
          <Container className='py-3'>
            <Row className='ad_game_box'>
            <Col xs="12" className="py-3">
              <div className="pb-0 ad_150pct mr-auto">
                <span className="fw-bold"><T>Leaderboard</T></span> - Alle spillere
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              <Table className="ad_leader_board bg-color-white">
                <thead>
                  <tr>
                    <th className="ad_th_1px"/>
                    <th><span className="ad_game_table_header font-s pl-3"><T>NAME</T></span></th>
                    <th className="d-none d-sm-table-cell"><span className="ad_game_table_header font-s"><T>TRADES</T></span></th>
                    <th className="d-none d-sm-table-cell"><span className="ad_game_table_header font-s"><T>TOTAL CHANGE</T></span></th>
                    <th className="text-end"><span className="ad_game_table_header font-s"><T>VALUE</T></span></th>
                  </tr>
                </thead>
                <tbody>
                  {portfolios.map((p, i) => {
                    const delta_money = calcDeltaMoney(p.Value, game.InitialAmount);
                    const delta_pct = calcDeltaPct(p.Value, game.InitialAmount);
                    const suffix = ` (${Number(delta_pct).toFixed(2)}%)`;

                    let row_class = "ad_game_table_border ad_grey_hover";

                    return (
                      <tr
                        className={`${row_class} ad_leaderboard_entry`}
                        key={p.Id}
                        onClick={() => window.location.href = `/portfolio/${p.Id}`}
                        tabIndex={0}
                        onKeyDown={e => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            window.location.href = `/portfolio/${p.Id}`;
                          }
                        }}
                        role="button"
                        aria-label={`Go to portfolio for ${p.OwnerScreenName}`}
                      >
                        <td className="text-right fw-bold">{page * PAGE_SIZE + i + 1}</td>
                        <td className="pl-4 mr-0 align-middle table-cell-min py-md-2 fw-bold">
                          <span className="text-overflow-dynamic-container">
                            <span className="text-overflow-dynamic-ellipsis">{p.OwnerScreenName}</span>
                          </span>
                        </td>
                        <td className="d-none d-sm-table-cell fw-bold txt-color-dark-black">
                          <span>{p.TradesCount}</span>
                        </td>
                        <td className="d-none d-sm-table-cell fw-bold">
                          <ChangeArrow currency_unit={game.Currency} pct={delta_money} suffix={suffix} />
                        </td>
                        <td className="text-end fw-bold">
                          <span>
                            {I18N.floatval_unit(p.Value, 2, game.Currency)}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
                            </Table>
              {/* Pagination Controls */}
              <div className="d-flex justify-content-between my-3">
                <Button
                  className='xyzzy_button  btn btn-outline-light'
                  disabled={page === 0}
                  onClick={() => setPage((p) => p - 1)}
                >
                  Forrige
                </Button>
                <div>
                  Side {page + 1} af {totalPages}
                </div>
                <Button
                  className='xyzzy_button  btn btn-outline-light'
                  disabled={page + 1 >= totalPages}
                  onClick={() => setPage((p) => p + 1)}
                >
                  Næste
                </Button>
              </div>
            </Col>
          </Row>
          </Container>
      );
    }
  );

  return (
    <LeaderboardBody gameId={gameId} page={page} />
  );
}



// WEBPACK FOOTER //
// ./src/p/FullLeaderboard.js